import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Button, Card, Dropdown, Space, Typography, message } from 'antd'
import dayjs from 'dayjs'
import PageHeader from '@/components/PageHeader'
import Permission from '@/components/PermissionA5'
import { DatePickerC, SelectC } from '@/i2antdV5'
import { formatDayString, renderTextStr } from '@/utils/renderUtils'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchTuinaTherapistScheduleGrouped } from '@/redux/tuina/therapistScheduleGroupedSlice'
import { fetchTuinaShiftOptions } from '@/redux/tuina/shiftOptionsSlice'
import { createTuinaTherapistSchedule, deleteTuinaTherapistSchedule } from '@/service/tuina'
import ScheduleImportModal from './share/ScheduleImportModal'
import ShiftListDrawer from './share/ShiftListDrawer'
import './Page.less'

const { Text } = Typography

const breadcrumbList = [
  { breadcrumbName: '按摩' },
  { breadcrumbName: '排班' }
]

function buildMonthDays (monthStart) {
  const n = monthStart.daysInMonth()
  const out = []
  for (let i = 0; i < n; i += 1) {
    out.push(monthStart.add(i, 'day'))
  }
  return out
}

function isWeekend (day) {
  const w = day.day()
  return w === 0 || w === 6
}

function popupParent () {
  return document.body
}

class TuinaRosterPage extends React.Component {
  state = {
    rosterQuery: { month: dayjs().format('YYYY-MM') },
    saving: false
  }

  didInitSchedule = false

  componentDidMount () {
    this.props.fetchJStoreList({ query: {}, dataType: 'optionTuina' })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载门店列表失败'))
  }

  componentDidUpdate (prevProps) {
    if (this.didInitSchedule) return
    if (this.props.getJStoreList.fetching) return
    if (!prevProps.getJStoreList.fetching) return
    this.didInitSchedule = true
    const options = this.props.getJStoreList.data
    const first = Array.isArray(options) && options[0]
    if (!first || first.id == null || first.id === '') {
      this.fetchSchedule({})
      return
    }
    this.fetchSchedule({ storeId: first.id })
  }

  fetchSchedule = (formatQuery = {}) => {
    const monthStart = dayjs(this.state.rosterQuery.month).startOf('month')
    if (!monthStart.isValid()) return
    const reduxQuery = this.props.therapistScheduleGrouped.query
    const storeId = formatQuery.storeId !== undefined ? formatQuery.storeId : reduxQuery.storeId
    const query = {
      year: monthStart.year(),
      month: monthStart.month() + 1
    }
    if (storeId != null && storeId !== '') query.storeId = storeId
    this.props
      .fetchTuinaTherapistScheduleGrouped({ query })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载排班失败'))
    const shiftQuery = {}
    if (storeId != null && storeId !== '') shiftQuery.storeId = storeId
    this.props
      .fetchTuinaShiftOptions({ query: shiftQuery })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载班次失败'))
  }

  fetchMonth = (formatQuery) => {
    if (!formatQuery.month) return
    this.setState(
      { rosterQuery: { month: formatQuery.month } },
      () => this.fetchSchedule(this.props.therapistScheduleGrouped.query)
    )
  }

  setMonth = (next) => {
    this.setState(
      { rosterQuery: { month: next.format('YYYY-MM') } },
      () => this.fetchSchedule(this.props.therapistScheduleGrouped.query)
    )
  }

  handleImportSuccess = () => {
    this.fetchSchedule(this.props.therapistScheduleGrouped.query)
  }

  handleCreateSchedule = (therapistId, day, shiftId, dayRows) => {
    const buttonCodes = this.props.permissionCodes.buttonCodes
    const canRosterControl = Array.isArray(buttonCodes) && buttonCodes.includes('tuina:roster:control')
    if (!canRosterControl) return
    if (therapistId == null || therapistId === '') return
    if (shiftId == null || shiftId === '') return
    const id = Number(shiftId)
    if (!Number.isFinite(id)) return
    if (this.state.saving) return
    const rows = Array.isArray(dayRows) ? dayRows : []
    this.setState({ saving: true })
    const run = async () => {
      for (let i = 0; i < rows.length; i += 1) {
        const scheduleId = rows[i].id
        if (scheduleId == null || scheduleId === '') continue
        await deleteTuinaTherapistSchedule(scheduleId)
      }
      await createTuinaTherapistSchedule({
        therapistId,
        workDate: +day.startOf('day'),
        shiftId: id
      })
    }
    run()
      .then(() => {
        message.success('已排班')
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ saving: false })
        this.fetchSchedule(this.props.therapistScheduleGrouped.query)
      })
  }

  render () {
    const { therapistScheduleGrouped, shiftOptions, getJStoreList, permissionCodes } = this.props
    const { query, data } = therapistScheduleGrouped
    const list = Array.isArray(data) ? data : []
    const jStoreOptions = getJStoreList.data
    const shiftRows = Array.isArray(shiftOptions.data) ? shiftOptions.data : []
    const shiftMenuItems = shiftRows.map((row) => ({
      key: String(row.value),
      label: row.label,
      disabled: row.disabled === true
    }))
    const { rosterQuery, saving } = this.state
    const buttonCodes = permissionCodes.buttonCodes
    const canRosterControl = Array.isArray(buttonCodes) && buttonCodes.includes('tuina:roster:control')
    const month = dayjs(rosterQuery.month).startOf('month')
    const days = buildMonthDays(month)
    const todayKey = formatDayString(dayjs())

    return (
      <div>
        <PageHeader title="排班" breadcrumbList={breadcrumbList} />
        <div className="i2-container">
          <Card className="i2-card-page">
            <section className="i2-app-toolbar tuina-roster-toolbar">
              <div className="toolbar-filters">
                <SelectC
                  label="门店"
                  query={query}
                  searchKey="storeId"
                  options={jStoreOptions}
                  action={this.fetchSchedule}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
              </div>
              <div className="toolbar-btns">
                <Permission rootPath="tuinaPage">
                  <span pathitem={['roster']} checkarray={['buttonCodes']}>
                    <ScheduleImportModal storeId={query.storeId} onSuccess={this.handleImportSuccess}>
                      <Button type="primary" size="large">导入</Button>
                    </ScheduleImportModal>
                  </span>
                </Permission>
                <ShiftListDrawer storeId={query.storeId}>
                  <Button size="large">班次</Button>
                </ShiftListDrawer>
              </div>
            </section>
            <section className="i2-app-toolbar tuina-roster-toolbar">
              <Space wrap size={8}>
                <Button
                  size="large"
                  icon={<LeftOutlined />}
                  aria-label="上个月"
                  onClick={() => this.setMonth(month.subtract(1, 'month'))}
                />
                <DatePickerC
                  label="月份"
                  query={rosterQuery}
                  searchKey="month"
                  picker="month"
                  dateStrValue
                  action={this.fetchMonth}
                  modalProps={{
                    picker: 'month',
                    allowClear: false,
                    size: 'large'
                  }}
                />
                <Button
                  size="large"
                  icon={<RightOutlined />}
                  aria-label="下个月"
                  onClick={() => this.setMonth(month.add(1, 'month'))}
                />
                <Button size="large" onClick={() => this.setMonth(dayjs().startOf('month'))}>
                  本月
                </Button>
                <Text type="secondary">
                  点格子选班次。全天休那天
                  <Link className="tuina-roster-board-link" to="/client/tuina/board">日看板</Link>
                  没有这一列。
                </Text>
              </Space>
            </section>
            <div className="tuina-roster-scroll">
              <table className="tuina-roster">
                <thead>
                  <tr>
                    <th className="tuina-roster-name">师傅</th>
                    {days.map((day) => {
                      const key = formatDayString(day)
                      const cls = [
                        key === todayKey ? 'is-today' : '',
                        isWeekend(day) ? 'is-weekend' : ''
                      ].filter(Boolean).join(' ')
                      return (
                        <th key={key} className={cls}>
                          <span className="tuina-roster-week">{day.format('dd')}</span>
                          <span className="tuina-roster-date">{day.format('D')}</span>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {list.map((tech) => {
                    const techId = String(tech.therapistId)
                    const byDate = {}
                    const schedules = Array.isArray(tech.schedules) ? tech.schedules : []
                    schedules.forEach((row) => {
                      const k = formatDayString(row.workDate)
                      if (!k) return
                      if (!byDate[k]) byDate[k] = []
                      byDate[k].push(row)
                    })
                    return (
                      <tr key={techId}>
                        <th className="tuina-roster-name">
                          <div className="tuina-roster-who">
                            <span className="tuina-roster-who-name">
                              {renderTextStr(tech.therapistName)}
                            </span>
                          </div>
                        </th>
                        {days.map((day) => {
                          const key = formatDayString(day)
                          const dayRows = byDate[key] || []
                          const firstRow = dayRows[0]
                          const curShiftId = firstRow && firstRow.shiftId
                          const apiText = dayRows.map((row) => row.shiftName).filter(Boolean).join(' ')
                          const cls = [
                            key === todayKey ? 'is-today' : '',
                            isWeekend(day) ? 'is-weekend' : ''
                          ].filter(Boolean).join(' ')
                          const cellKind = !firstRow
                            ? ''
                            : firstRow.shiftBookable === false
                              ? 'is-rest'
                              : 'is-work'
                          const cell = (
                            <button
                              type="button"
                              className={['tuina-roster-cell', cellKind].filter(Boolean).join(' ')}
                              disabled={!canRosterControl || saving}
                              aria-label={`${tech.therapistName} ${day.format('M月D日')} ${apiText || '未排班'}`}
                              aria-haspopup={canRosterControl ? 'menu' : undefined}
                            >
                              {apiText}
                            </button>
                          )
                          if (!canRosterControl) {
                            return (
                              <td key={key} className={cls}>
                                {cell}
                              </td>
                            )
                          }
                          return (
                            <td key={key} className={cls}>
                              <Dropdown
                                trigger={['click']}
                                getPopupContainer={popupParent}
                                menu={{
                                  selectable: true,
                                  selectedKeys: curShiftId != null && curShiftId !== '' ? [String(curShiftId)] : [],
                                  items: shiftMenuItems,
                                  onClick: ({ key: next }) => {
                                    if (String(curShiftId) === String(next)) return
                                    this.handleCreateSchedule(tech.therapistId, day, next, dayRows)
                                  }
                                }}
                              >
                                {cell}
                              </Dropdown>
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <Text type="secondary" className="tuina-roster-note">
              改成休或只上半天：落在休息时段、还未开始的预约会取消并退次回卡。有正在做的，不能改成休或半天。
            </Text>
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  therapistScheduleGrouped: state.tuina.therapistScheduleGrouped,
  shiftOptions: state.tuina.shiftOptions,
  getJStoreList: state.components.getJStoreList,
  permissionCodes: state.app.permissionCodes
})

const mapDispatchToProps = {
  fetchTuinaTherapistScheduleGrouped,
  fetchTuinaShiftOptions,
  fetchJStoreList
}

export default connect(mapStateToProps, mapDispatchToProps)(TuinaRosterPage)
